import { useSelector } from 'react-redux';
import {
  InputField,
  BulkImageUploadField,
  RadioField,
} from '../../../../components/FormComponents';
import { Text } from '../../../../ui-component';
import { useGetSiteConstantValue } from '../../../../utils/hooks/useGetSiteConstantValue';

import type { RootState } from '../../../../store';

import ProfilePicUpload from '../ProfilePicUpload';
import { TAILOR_OPTIONS } from '../../contant';

type StepOneProps = {
  handleChange: (value: any, key: string) => void;
};

const StepOne = (props: StepOneProps) => {
  const { handleChange } = props;

  const { onboardingReducer } = useSelector((state: RootState) => state);
  const { profileData } = onboardingReducer;

  const { getSiteConstantValue } = useGetSiteConstantValue();

  return (
    <>
      <Text size="xxxl" color="black" fontWeight={800}>
        {getSiteConstantValue('profile', 'enterYourDetails')}
      </Text>

      <ProfilePicUpload
        value={profileData?.profile_pic_url ?? {}}
        onChange={(value) => handleChange(value, 'profile_pic_url')}
      />

      <InputField
        label={getSiteConstantValue('profile', 'enterFullName')}
        placeholder={getSiteConstantValue('profile', 'enterFullName')}
        type="text"
        required={true}
        value={profileData?.tailor_name ?? ''}
        onChange={(value) => handleChange(value, 'tailor_name')}
      />

      <InputField
        label={getSiteConstantValue('profile', 'enterShopName')}
        placeholder={getSiteConstantValue('profile', 'enterShopName')}
        type="text"
        required={true}
        value={profileData?.boutique_details?.boutique_name ?? ''}
        onChange={(value) => handleChange(value, 'boutique_details.boutique_name')}
      />

      <RadioField
        label={getSiteConstantValue('profile', 'typeOfTailor')}
        type="radio"
        required={true}
        value={profileData?.boutique_details?.boutique_type ?? ''}
        options={TAILOR_OPTIONS}
        onChange={(value) => handleChange(value, 'boutique_details.boutique_type')}
      />

      <BulkImageUploadField
        label={getSiteConstantValue('profile', 'uploadShopPicture')}
        placeholder={getSiteConstantValue('profile', 'uploadShopPicture')}
        type="file"
        required={false}
        multiple={true}
        maxUpload={3}
        fileTypeRequired={false}
        value={profileData?.boutique_details?.shop_image_urls ?? []}
        onChange={(value) => handleChange(value, 'boutique_details.shop_image_urls')}
      />
    </>
  );
};

export default StepOne;
